import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/channel/$handle')({
  loader: ({ params }) =>
    redirect({
      statusCode: 301,
      throw: false,
      to: `/store/${params.handle}`,
    }),
})
